module.exports = __webpack_public_path__ + "static/img/wanted1.8503b18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/wanted1.png
// module id = 6PAG
// module chunks = 1 3